var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Input from '.';
// onchange example----------------------------------------------------
// export const InputChange = UpdateData => e => {
//     UpdateData({ [e.target.name]: e.target.value });
// }
// const----------------------------------------------------
// InputEngName------------------------------------------------
var charEngName = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'J',
    'K',
    'L',
    'M',
    'N',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'X',
    'Y',
    'W',
    'Z',
    'I',
    'O',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'j',
    'k',
    'l',
    'm',
    'n',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'x',
    'y',
    'w',
    'z',
    'i',
    'o',
    ' ',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '.',
];
export var EngNameCheck = function (value) {
    var errIdx = value
        .split('')
        .findIndex(function (obj) { return charEngName.indexOf(obj) === -1; });
    return errIdx === -1;
};
export var EngNameError = function (value) { return !EngNameCheck(value); };
var InputEngName = function (props) {
    var _a = props.verifiers, verifiers = _a === void 0 ? [] : _a, other = __rest(props, ["verifiers"]);
    return (React.createElement(Input, __assign({}, other, { verifiers: __spreadArrays(verifiers, [
            { func: EngNameError, text: '請填寫正確的英文姓名。' },
        ]) })));
};
export default InputEngName;
